import React from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { Headphones } from 'react-feather';
import CentralizeButton from '../../../../VuexyDesign/atoms/CentralizeButton';

export const RequestFeedbackButton = styled(
  ({ onClick, className }: { onClick: () => void; className?: string }) => {
    const { t } = useTranslation('profile');
    return (
      <CentralizeButton
        color="info"
        size="sm"
        text={t('profile:requestFeedback') as string}
        className={className}
        isIconLeftSide
        onClick={onClick}
        icon={Headphones}
      />
    );
  },
)``;
